import {
  enumElementDrawStates,
  kCellInner,
  kCellOuter,
  kDisableColor,
  kHoverInnerColor,
  kHoverOuterColor,
  kSelectInnerColor,
  kSelectOuterColor,
  kStartOuterColor
} from "../constants";
import { getHoverTip } from "../utils/getHoverTip";
import { QElement } from "./QElement";

export class QColorButton extends QElement {
  constructor() {
    //this.fLabel = "<Not Set>";
    super();
    this.fColorName = "";
    this.fStartColor = false; // Mark this button because it is the color that is currently used by the selected element
    this.fCustomColor = false;
  }

  SetAsCustom(customColor) {
    this.fCustomColor = customColor;
    this.SetDblClickCmd("CustomColor");
  }

  SetColorCode(colorCode) {
    this.fColorName = getHoverTip(colorCode);
    this.SetHoverCode(colorCode);
  }

  SetInteriorColor(buttonColor) {
    this.fInteriorColor = buttonColor;
  }

  GetInteriorColor() {
    return this.fInteriorColor; // = buttonColor;
  }

  SetAsStartColor(isStartColor) {
    this.fStartColor = isStartColor;
  }

  RenderInterior(drawBuffer, disabled) {
    var interiorColor = this.fInteriorColor;

    var ctx = drawBuffer.getContext("2d");
    if (!disabled) {
      ctx.fillStyle = interiorColor;
      //ctx.fillRect(this.fHorzOffset+2,this.fVertOffset+2,this.fWidth-4,this.fHeight-4);
      ctx.fillRect(this.fHorzOffset + 2, this.fVertOffset + 2, this.fWidth - 4, this.fHeight - 4);
    }
  }

  DoRenderElement(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    var innerColor = kCellInner;
    var outerColor = kCellOuter;
    var disabled = false;

    switch (this.GetDrawState()) {
      case enumElementDrawStates.Std:
        //innerColor = kCellInner;
        if (this.fStartColor) outerColor = kStartOuterColor;
        break;
      case enumElementDrawStates.Hover:
        outerColor = kHoverOuterColor; // Orange
        innerColor = kHoverInnerColor; // Light orange
        break;
      case enumElementDrawStates.MouseDown:
        outerColor = kSelectOuterColor; // Red
        innerColor = kSelectInnerColor; // Light orange
        break;
      case enumElementDrawStates.Disabled:
        innerColor = kDisableColor;
        break;
    }

    ctx.fillStyle = outerColor;
    ctx.fillRect(this.fHorzOffset, this.fVertOffset, this.fWidth, this.fHeight);
    ctx.fillStyle = innerColor;
    ctx.fillRect(this.fHorzOffset + 1, this.fVertOffset + 1, this.fWidth - 2, this.fHeight - 2);
    this.RenderInterior(drawBuffer, disabled);
  }
}
